export default "__VITE_ASSET__DqLb2A7r__"